import { TopBar } from '@/layouts/TopBar';
import Paths from '@/routes/paths';
import { JButton } from '@atoms/JButton';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetDetailsTopUp } from '../queries';
import DetailsTopUp from '../components/molecules/DetailsTopUp';
import RepartitionTopUp from '../components/organisms/RepartitionTopUp';

const DetailsTopUpsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: topUpDetailsData } = useGetDetailsTopUp(id ?? '');
  return (
    <>
      <TopBar title={t('DETAILS_TOP_UP')}>
        <JButton onClick={() => navigate(Paths.CreditsPage)} variant="text">
          {t('QUIT')}
        </JButton>
      </TopBar>
      {topUpDetailsData && (
        <Stack direction={'row'} gap={6} padding={6}>
          <DetailsTopUp topUps={topUpDetailsData?.data} />
          <RepartitionTopUp topUps={topUpDetailsData?.data} />
        </Stack>
      )}
    </>
  );
};

export default DetailsTopUpsPage;
